import Gooey, {
  Model,
  ClassComponent,
  model,
  calc,
  mount,
} from '@srhazi/gooey';
let id = 0;

// We had two <label> & <input> pairs, so let's break each into a single component
interface LabeledInputProps {
  /** children - the displayed contents of the label */
  children: JSX.Node;

  /** onUpdate - called when the input value changes at all */
  onUpdate: (value: string) => void;

  /** minlength - an optional constraint on length */
  minlength?: string;

  /** type - the kind of input we're dealing with */
  type?: 'text' | 'password';
}

class LabeledInput extends ClassComponent<LabeledInputProps> {
  uniqueId: string;

  constructor(props: LabeledInputProps) {
    super(props);
    this.uniqueId = `input_${id++}_5`;
  }

  render() {
    return (
      <p>
        <label for={this.uniqueId}>{this.props.children}: </label>
        <input
          id={this.uniqueId}
          type={this.props.type ?? 'text'}
          minlength={this.props.minlength}
          on:input={(event, inputEl) => this.props.onUpdate(inputEl.value)}
        />
      </p>
    );
  }
}

// And let's build a form component to hold the state for all the fields, and have an optional callback
interface AuthenticationFormProps {
  onSubmit: (username: string, password: string) => void;
}
class AuthenticationForm extends ClassComponent<AuthenticationFormProps> {
  state: Model<{ username: string; password: string }>;

  constructor(props: AuthenticationFormProps) {
    super(props);
    this.state = model({ username: '', password: '' });
  }

  onSubmitClick = () => {
    this.props.onSubmit(this.state.username, this.state.password);
  };

  onUpdateUsername = (val: string) => {
    this.state.username = val;
  };

  onUpdatePassword = (val: string) => {
    this.state.password = val;
  };

  calcIsInvalid = calc(
    () => this.state.username.length < 3 || this.state.password.length === 0
  );

  render() {
    return (
      <fieldset>
        <legend>Example Login</legend>
        <LabeledInput
          type="text"
          minlength="3"
          onUpdate={this.onUpdateUsername}
        >
          Username
        </LabeledInput>
        <LabeledInput type="password" onUpdate={this.onUpdatePassword}>
          Password
        </LabeledInput>
        <button
          type="submit"
          disabled={this.calcIsInvalid}
          on:click={this.onSubmitClick}
        >
          Submit
        </button>
      </fieldset>
    );
  }
}

// To demonstrate that this all fits together, we can now have multiple
// instances of the AuthenticationForm component!
mount(
  document.getElementById('walkthrough-5.tsx')!,
  <>
    <AuthenticationForm
      onSubmit={(username, password) =>
        alert(`Submit one: ${username} + ${password}`)
      }
    />
    <AuthenticationForm
      onSubmit={(username, password) =>
        alert(`Submit two: ${username} + ${password}`)
      }
    />
  </>
);
